import { Component } from '@angular/core';

@Component({
  template: '<router-outlet></router-outlet><router-outlet name="modal"></router-outlet><router-outlet name="message"></router-outlet>'
})
export class EmptyComponent {}
